<h1 mat-dialog-title>Send SMS</h1>
<div mat-dialog-content>
    <div>
        Send SMS to {{data.customer.name}} on <span [apPhone]="data.customer.phone">{{data.customer.phone | phone}}</span>
    </div>

    <mat-form-field class="sms-text" appearance="outline">
        <textarea rows="8" [(ngModel)]="body" [disabled]="isSending" matTextareaAutosize matInput placeholder="SMS to send"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-dialog-close mat-button [disabled]="isSending">Cancel</button>
    <button mat-raised-button color="primary" cdkFocusInitial (click)="confirm()" [disabled]="isSending">
        {{ isSending ? 'Sending...' : 'Send SMS' }}
    </button>
</div>
